export default "__VITE_ASSET__VvRagS7C__"